const late_train = `Subject: Complaint Regarding Train Delay
To Whom It May Concern,
I am writing to express my deep frustration regarding the significant delay of my recent train journey with VR. 
The train I boarded on [date] arrived at my destination 45 minutes behind schedule, 
causing me to be late for a crucial meeting.
This delay had a considerable impact on my professional commitments, 
resulting in missed opportunities and potential financial consequences. 
Moreover, it caused unnecessary stress and inconvenience, 
disrupting my carefully planned schedule for the day.
In light of this situation, 
I urge VR to take immediate measures to improve the punctuality of train services and ensure that such significant delays do not occur in the future. 
Implementing better maintenance practices and adhering to more efficient scheduling protocols could help mitigate the frequency of such disruptions and uphold the reliability of your services.
I appreciate your prompt attention to this matter and trust that necessary steps will be taken to prevent similar incidents from recurring.
Sincerely,`;
export default late_train;